<template>
  <div class="choose-experience-banner">
    <div class="choose-experience-banner__text">
      <p class="choose-experience-banner__caption">{{ t('banner.captionMobile') }}</p>
      <p class="choose-experience-banner__count">{{ t('banner.count', count) }}</p>
    </div>
    <UiButton
      :text="t('banner.button')"
      :color-mode="UiButtonColorMode.NEUTRAL"
      :variant="UiButtonVariant.PRIMARY"
      :size="UiButtonSize.M"
      :is-full-width="isMobile"
      :href="href"
    />
  </div>
</template>

<script setup lang="ts">
import { UiButton, UiButtonColorMode, UiButtonSize, UiButtonVariant } from '@experience/core-button-ui';
import { useI18n } from '@experience/i18n';

import { useScreenSize } from '@/shared/utils/breakpoints';

import ru from '../i18n/ru.json';

defineProps<{
  count: number;
  href: string;
}>();

const { isMobile } = useScreenSize();

const { t } = useI18n<{ message: typeof ru }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});
</script>

<style scoped lang="scss">
.choose-experience-banner {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
  background-color: var(--alias-color-background-subtle);
  border-radius: 16px;

  @include tablet {
    padding: 20px 24px;
  }

  @include mobile {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
}

.choose-experience-banner__text {
  @include mobile {
    display: flex;
    flex-direction: column-reverse;
  }
}

.choose-experience-banner__caption {
  margin: 0;

  @include typography.base-400-300-regular;
}

.choose-experience-banner__count {
  margin: 4px 0 0;
  color: var(--alias-color-text-default);

  @include typography.base-700-700-semi;

  @include mobile {
    margin: 0 0 4px;

    @include typography.base-600-500-semi;
  }
}
</style>
